// Reads the Form Mode builder (HAML + select2 + React islands) for the
// tagged URL preview (#2627). select2 mirrors its value onto the <select>,
// and the React islands write hidden inputs, so reading by name covers all.

// The destination field: the multi-URL textarea on new, the single URL input on edit.
export const URLS_FIELD = '[data-tagged-url-preview-urls]';

export function readBuilderForm(form, params) {
  const urls = form.querySelector(URLS_FIELD).value
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  // One pass over the form: the last non-blank value wins per input name.
  const filledByName = {};
  Array.from(form.elements).forEach(({ name, value }) => {
    if (name && value && value.trim() !== '') filledByName[name] = value;
  });

  const values = {};
  params.forEach(({ key, inputName }) => {
    values[key] = filledByName[inputName] || '';
  });

  return { urls, values };
}
